import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="site-footer">
            <div className="footer-glow footer-glow-left" aria-hidden="true" />
            <div className="footer-glow footer-glow-right" aria-hidden="true" />

            <div className="container footer-container">
                <div className="footer-main">
                    <div className="footer-brand-section">
                        <Link
                            to="/"
                            className="footer-brand"
                            aria-label="TripSplitter home"
                        >
                            <span className="footer-logo-mark" aria-hidden="true">
                                TS
                            </span>

                            <span className="footer-brand-name">TripSplitter</span>
                        </Link>

                        <p className="footer-description">
                            Easily split expenses and settle balances with friends. Simple,
                            private and open-source.
                        </p>
                    </div>

                    <nav className="footer-navigation" aria-label="Footer navigation">
                        <div className="footer-link-group">
                            <p className="footer-link-heading">Product</p>

                            <ul className="footer-link-list">
                                <li>
                                    <Link to="/about" className="footer-link">
                                        How it works
                                    </Link>
                                </li>

                                <li>
                                    <Link to="/privacy" className="footer-link">
                                        Privacy
                                    </Link>
                                </li>

                                <li>
                                    <Link to="/terms" className="footer-link">
                                        Terms
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>

                <div className="footer-bottom">
                    <p className="footer-copyright">
                        © {currentYear} TripSplitter. All rights reserved.
                    </p>

                    <p className="footer-tagline">
                        Split fairly. Settle simply.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;